import React from 'react';
import LanguageButtonDPC from "./dpc-language-button-attimodecisivo";
import LogoSVG from "../../img/INR_Logo_FondoBianco_1.svg";
import NavbarDPC from "./dpc-navbar-attimodecisivo";
import SvgIconDPC from "../dpc-svg-icon-iononrischio";
import {buildMenu} from "../../js/shared-functions";
import {navigate} from "@reach/router";
import PersonaggiINR from "../../img/personaggi_header_1.png";
import LogoINR from "../../img/INR_Logo_FondoBianco_1.svg";
import logoPersona from "../../img/personaggi_header.png";
import payoff from "../../img/logo_desktop.png";
import LogoAD from "../../img/logo_desktop.png";
import headerMobile from "../../img/header_mobile_4.jpg";
import GoogleAnalytics from './dpc-googleAnalytics';
import GoogleTagManager from './dpc-googleTagManager';

export default class DpcHeaderAttimoDecisivo extends React.Component {

    constructor(props) {
        super(props);
        this.state = {value: ''};
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }


    handleSubmit(event) {
        event.persist();
        event.preventDefault();
        const path = `/${this.props.lang}/risultati-ricerca/`;
        navigate(path, {
                state: {search: this.state.value},
                replace: false
            }
        )
        //this.setState({redirect: true})
    }

    handleInputChange(event) {
        event.persist();
        this.setState({value: event.target.value});
    }

    getMenu = (menuItems) => {
        return this.props.subdomain
            ? buildMenu(menuItems, this.props.lang, this.props.env, this.props.basePathNavbar, this.props.contenutoId, this.props.minisiti)
            : buildMenu(menuItems, this.props.lang, this.props.env, null, this.props.contenutoId, this.props.minisiti)
    };

    getHomePath = () => {
        if (this.props.subdomain) {
            return `${this.props.basePathNavbar}/${this.props.lang}/`
        } else {
            return `/${this.props.lang}/`
        }
    }

    getMinisitoUrl = () => {
        var subdomain = "";
        if(this.props.lang === 'it'){
            subdomain = this.props.subdomain;
        }else{
            subdomain = this.getLabel(this.props.subdomain);
        }
        return this.props.minisiti[`MINISITO_${subdomain.toUpperCase().replace(new RegExp("[\\s-]+", "g"), '_')}_URL`]
    }

    getLabel = (subdomain) => {
        switch(subdomain){
            case process.env.MINISITO_EMERGENZE_LABEL_EN:
                return process.env.MINISITO_EMERGENZE_LABEL;
            case process.env.MINISITO_RISCHI_LABEL_EN:
                return process.env.MINISITO_RISCHI_LABEL;
            case process.env.MINISITO_VOLONTARIATO_LABEL_EN:
                return process.env.MINISITO_VOLONTARIATO_LABEL;
            case process.env.MINISITO_DOMANDE_E_RISPOSTE_LABEL_EN:
                return process.env.MINISITO_DOMANDE_E_RISPOSTE_LABEL;
            case process.env.MINISITO_FORMAZIONE_LABEL_EN:
                return process.env.MINISITO_FORMAZIONE_LABEL;
            case process.env.MINISITO_MAPPE_LABEL_EN:
                return process.env.MINISITO_MAPPE_LABEL;
            case process.env.MINISITO_EVENTI_LABEL_EN:
                return process.env.MINISITO_EVENTI_LABEL;
            case process.env.MINISITO_RELAZIONI_INTERNAZIONALI_LABEL_EN:
                return process.env.MINISITO_RELAZIONI_INTERNAZIONALI_LABEL;
            case process.env.MINISITO_CAPRISCHIO_21_27_LABEL_EN:
                return process.env.MINISITO_CAPRISCHIO_21_27_LABEL;
            case process.env.MINISITO_SERVIZIO_NAZIONALE_LABEL_EN:
                return process.env.MINISITO_SERVIZIO_NAZIONALE_LABEL;
            case process.env.MINISITO_ATTUAZIONE_MISURE_PNRR_LABEL_EN:
                return process.env.MINISITO_ATTUAZIONE_MISURE_PNRR_LABEL;
            default:
                return "";

        }
    }

    render() {
        return (
            <header
                className={`it-header-wrapper it-shadow ${this.props.isLanding ? 'INRLandingPage':'it-header-sticky'}` }
                role="banner">
                <GoogleAnalytics trackingId="G-WN5YDP3Y1W" />
                <GoogleTagManager />
                <LanguageButtonDPC slugTraduzione={this.props.slugTraduzione} env={this.props.env}
                                   lang={this.props.lang}/>
                <div className="it-subheader-attimodecisivo">
                    <div className="container customContainer">
                        <a href="https://www.protezionecivile.gov.it"  title="Dipartimento della Protezione Civile"
                           target="_blank" rel="noopener" className="text-sub-header">Dipartimento della Protezione Civile
                        </a>
                    </div>
                </div>
                <div className="it-nav-wrapper">
                    <div className="it-header-center-wrapper it-header-center-wrapper-versione-alt">
                        <div className="container">
                            <div className="it-header-center-content-wrapper">
                                <div className="it-brand-wrapper">
                                    <ul className="list-inline">
                                        <li className="list-inline-item">
                                            <div className="navbar-brand">                                                       
                                                {<a href={this.getHomePath()} title="L’attimo decisivo">
                                                    <img height={"45px"} className="logo-ad" src={LogoAD} alt="L'attimo decisivo"/>
                                                </a>}
                                                
                                                <div className="d-flex flex-column align-items-start">
                                                    <a href={this.getHomePath()}
                                                         title="L'attimo decisivo">
                                                    <img height={"165px"} className="logopersona" src={logoPersona} alt=""/>
                                                    </a>
                                                    <a href={this.getHomePath()}
                                                        title="L'attimo decisivo">
                                                    <img className="payoff" src={payoff} alt=""/>
                                                    </a>
                                                    <h2 className="sr-only">L'attimo decisivo</h2>
                                                </div>
                                            
                                            </div>
                                        </li>
                                    </ul>
                                </div>

                                <div className="it-right-zone">
                                    {/*!this.props.isLanding ?
                                     <div className="it-search-wrapper">
                                        <form role="search" id="searchFormHeader" onSubmit={this.handleSubmit}>
                                            <label for="searchQueryHeader" className="sr-only">Cerca nel sito</label>
                                            <input type="search" id="searchQueryHeader" name="searchQueryHeader"
                                                placeholder="Cerca nel sito..." onChange={this.handleInputChange} value={this.state.value}/>
                                            <button type="submit" className="search-link-custom rounded-icon" id="searchSubmitHeader">
                                                <SvgIconDPC name={'fa-search'}/>
                                            </button>
                                        </form>
                                    </div>: null*/}
                                </div>

                            </div>
                        </div>
                    </div>
                    {!this.props.isLanding ?
                    <NavbarDPC menuItems={this.getMenu(this.props.menuItems)} lang={this.props.lang}/>
                    : null}
                </div>
                { this.props.isHomepage && 
                <div class="it-nav-image">
                    <img src={headerMobile} alt=""/>
                </div>
                }
            </header>)
    }
};
